import React from "react";

const PropertyCardSkeleton = () => {
  const pulseStyle = {
    animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
  };

  const skeletonStyles = {
    backgroundColor: "#e5e7eb", // gray-200
    borderRadius: "15px 15px 0 0",
    height: "300px",
    width: "100%",
  };

  const contentStyles = {
    backgroundColor: "#e5e7eb", // gray-200
    borderRadius: "0 0 15px 15px",
    padding: "16px 14px", // px-3.5 py-4
  };

  const elementStyles = {
    backgroundColor: "#d1d5db", // gray-300
    borderRadius: "4px",
  };
  // TODO: use https://ui.shadcn.com/docs/components/skeleton
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {/* Image skeleton */}
      <div style={{ ...skeletonStyles, ...pulseStyle }}></div>

      {/* Content skeleton */}
      <div style={{ ...contentStyles, ...pulseStyle }}>
        {/* Title skeleton - max-h-20 min-h-10 mb-5 */}
        <div
          style={{
            ...elementStyles,
            height: "80px", // max-h-20 = 80px
            marginBottom: "20px", // mb-5 = 20px
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />

        {/* Bedroom/Bathroom/Living room skeleton - h-10 min-h-10 mb-5 mt-3.5 */}
        <div
          style={{
            display: "none",
            height: "40px", // h-10 = 40px
            marginBottom: "20px", // mb-5 = 20px
            marginTop: "14px", // mt-3.5 = 14px
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
          className="md:flex"
        >
          <div
            style={{
              width: "33.33%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <div style={{ ...elementStyles, width: "50px", height: "33px", marginRight: "10px" }} />
            <div style={{ ...elementStyles, width: "24px", height: "24px" }} />
          </div>
          <div
            style={{
              width: "33.33%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <div style={{ ...elementStyles, width: "50px", height: "32px", marginRight: "10px" }} />
            <div style={{ ...elementStyles, width: "24px", height: "24px" }} />
          </div>
          <div
            style={{
              width: "33.33%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <div style={{ ...elementStyles, width: "50px", height: "27px", marginRight: "10px" }} />
            <div style={{ ...elementStyles, width: "24px", height: "24px" }} />
          </div>
        </div>

        {/* Price skeleton - h-[2.875rem] min-h-[2.875rem] mb-5 */}
        <div
          style={{
            height: "46px", // h-[2.875rem] = 46px
            marginBottom: "20px", // mb-5 = 20px
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div style={{ ...elementStyles, height: "23px", marginBottom: "8px" }} />
          <div style={{ ...elementStyles, height: "23px" }} />
        </div>

        {/* Description skeleton - h-[5.75rem] min-h-[5.75rem] mb-5 */}
        <div
          style={{
            display: "none",
            height: "92px", // h-[5.75rem] = 92px
            marginBottom: "20px", // mb-5 = 20px
            flexDirection: "column",
            justifyContent: "space-between",
          }}
          className="md:block"
        >
          <div style={{ ...elementStyles, height: "23px" }} />
          <div style={{ ...elementStyles, height: "23px" }} />
          <div style={{ ...elementStyles, height: "23px" }} />
          <div style={{ ...elementStyles, height: "23px", width: "75%" }} />
        </div>

        {/* Footer skeleton */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            height: "40px", // Approximate footer height
          }}
          className="md:justify-between"
        >
          {/* Desktop footer */}
          <div
            style={{
              display: "none",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
            className="md:flex"
          >
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <div style={{ ...elementStyles, width: "120px", height: "24px" }} />
              <div
                style={{ ...elementStyles, width: "16px", height: "16px", marginLeft: "12px" }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
              <div
                style={{ ...elementStyles, width: "64px", height: "16px", marginBottom: "4px" }}
              />
              <div style={{ ...elementStyles, width: "80px", height: "16px" }} />
            </div>
          </div>
          {/* Mobile footer */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
            }}
            className="md:hidden"
          >
            <div style={{ ...elementStyles, width: "100px", height: "24px" }} />
            <div style={{ ...elementStyles, width: "16px", height: "16px" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyCardSkeleton;
